import { samanthaMediaArray } from './samanthaMedia'
import { samanthaBio } from './samanthaBios'
import { carrieProfileReviewHinge, mirandaProfileReviewBumble, charlotteProfileReviewTinder } from './samanthaProfileReviews'

export const samanthaDatingProfileHinge = {
  _id: 'samanthaDatingProfileHingeId',
  userId: 'samanthaUserId',
  email: 'samantha@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: samanthaMediaArray[4]._id,
      mediaItemURL: samanthaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[4].type,
      caption: samanthaMediaArray[4].captions[0],
      subcaption: samanthaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[1]._id,
      mediaItemURL: samanthaMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[1].type,
      caption: samanthaMediaArray[1].captions[0],
      subcaption: samanthaMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[3]._id,
      mediaItemURL: samanthaMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[3].type,
      caption: samanthaMediaArray[3].captions[0],
      subcaption: samanthaMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[7]._id,
      mediaItemURL: samanthaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[7].type,
      caption: samanthaMediaArray[7].captions[0],
      subcaption: samanthaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[0]._id,
      mediaItemURL: samanthaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[0].type,
      caption: samanthaMediaArray[0].captions[0],
      subcaption: samanthaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[2]._id,
      mediaItemURL: samanthaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[2].type,
      caption: samanthaMediaArray[2].captions[0],
      subcaption: samanthaMediaArray[2].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: samanthaBio._id,
    vitalInfo: { ...samanthaBio.vitalInfo },
    prompts: [
      { ...samanthaBio.prompts[0] },
      { ...samanthaBio.prompts[1] },
      { ...samanthaBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...carrieProfileReviewHinge }
  ],
  mediaItems: [ ...samanthaMediaArray ],
  bioItems: { ...samanthaBio },
}

export const samanthaDatingProfileBumble = {
  _id: 'samanthaDatingProfileBumbleId',
  userId: 'samanthaUserId',
  email: 'samantha@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: samanthaMediaArray[4]._id,
      mediaItemURL: samanthaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[4].type,
      caption: samanthaMediaArray[4].captions[0],
      subcaption: samanthaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[1]._id,
      mediaItemURL: samanthaMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[1].type,
      caption: samanthaMediaArray[1].captions[0],
      subcaption: samanthaMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[3]._id,
      mediaItemURL: samanthaMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[3].type,
      caption: samanthaMediaArray[3].captions[0],
      subcaption: samanthaMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[7]._id,
      mediaItemURL: samanthaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[7].type,
      caption: samanthaMediaArray[7].captions[0],
      subcaption: samanthaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[0]._id,
      mediaItemURL: samanthaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[0].type,
      caption: samanthaMediaArray[0].captions[0],
      subcaption: samanthaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[2]._id,
      mediaItemURL: samanthaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[2].type,
      caption: samanthaMediaArray[2].captions[0],
      subcaption: samanthaMediaArray[2].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: samanthaBio._id,
    vitalInfo: { ...samanthaBio.vitalInfo },
    prompts: [
      { ...samanthaBio.prompts[0] },
      { ...samanthaBio.prompts[1] },
      { ...samanthaBio.prompts[2] }
    ],
    aboutMe: samanthaBio.aboutMe[0],
    hobbies: [samanthaBio.hobbies[0], samanthaBio.hobbies[1], samanthaBio.hobbies[2], samanthaBio.hobbies[3], samanthaBio.hobbies[4] ],
  },
  profileReviews: [
    { ...mirandaProfileReviewBumble }
  ],
  mediaItems: [ ...samanthaMediaArray ],
  bioItems: { ...samanthaBio },
}

export const samanthaDatingProfileTinder = {
  _id: 'samanthaDatingProfileTinderId',
  userId: 'samanthaUserId',
  email: 'samantha@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: samanthaMediaArray[4]._id,
      mediaItemURL: samanthaMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[4].type,
      caption: samanthaMediaArray[4].captions[0],
      subcaption: samanthaMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[1]._id,
      mediaItemURL: samanthaMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[1].type,
      caption: samanthaMediaArray[1].captions[0],
      subcaption: samanthaMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[3]._id,
      mediaItemURL: samanthaMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[3].type,
      caption: samanthaMediaArray[3].captions[0],
      subcaption: samanthaMediaArray[3].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[7]._id,
      mediaItemURL: samanthaMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[7].type,
      caption: samanthaMediaArray[7].captions[0],
      subcaption: samanthaMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[0]._id,
      mediaItemURL: samanthaMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[0].type,
      caption: samanthaMediaArray[0].captions[0],
      subcaption: samanthaMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: samanthaMediaArray[2]._id,
      mediaItemURL: samanthaMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: samanthaMediaArray[2].type,
      caption: samanthaMediaArray[2].captions[0],
      subcaption: samanthaMediaArray[2].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: samanthaBio._id,
    vitalInfo: { ...samanthaBio.vitalInfo },
    prompts: [
      { ...samanthaBio.prompts[0] },
      { ...samanthaBio.prompts[1] },
      { ...samanthaBio.prompts[2] }
    ],
    aboutMe: samanthaBio.aboutMe[0],
    hobbies: [samanthaBio.hobbies[0], samanthaBio.hobbies[1], samanthaBio.hobbies[2], samanthaBio.hobbies[3], samanthaBio.hobbies[4] ],
  },
  profileReviews: [
    { ...charlotteProfileReviewTinder }
  ],
  mediaItems: [ ...samanthaMediaArray ],
  bioItems: { ...samanthaBio },
}